"use client";

import { IconButton, InputAdornment, TextField } from "@mui/material";
import CopyIcon from "@mui/icons-material/ContentCopy";
import EmailButton from "./EmailButton";
import SlackButton from "./SlackButton";
import TeamsButton from "./TeamsButton";

export default function Buttons({
  transcriptText,
  meetingTitle,
  insightSummary,
  organizationName,
  shareLink,
}: {
  transcriptText: string;
  meetingTitle: string;
  insightSummary?: string;
  organizationName: string;
  shareLink: string;
}) {
  return (
    <>
      <div className="flex items-center justify-center gap-2 mb-2">
        <EmailButton
          shareLink={shareLink}
          rawText={transcriptText}
          title={meetingTitle}
          insightSummary={insightSummary}
          organizationName={organizationName}
        />
        <SlackButton
          shareLink={shareLink}
          rawText={transcriptText}
          title={meetingTitle}
          insightSummary={insightSummary}
          organizationName={organizationName}
        />
        <TeamsButton shareLink={shareLink} />
      </div>
      <TextField
        fullWidth
        value={shareLink}
        label="Share Link"
        size="small"
        slotProps={{
          input: {
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  color="primary"
                  onClick={() => {
                    navigator.clipboard.writeText(shareLink);
                  }}
                >
                  <CopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </>
  );
}
